function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "color"
}, /*#__PURE__*/React.createElement("line", {
  x1: 51,
  x2: 51,
  y1: 47.42,
  y2: 33.14,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "skin"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m42.03 47.56c-0.3312 2.471-2.599 7.032-5.057 6.7-0.293-0.03821-0.6495-0.1401-1.045-0.293 0.8407-3.095 5.477-7.923 6.114-9.579l-0.01274 1.987c0.05095 0.3949 0.05095 0.8025 0 1.185z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m33.19 24.09-0.01274 1.223h0.01274c0.05095-0.4204 0.05095-0.828 0-1.223zm8.917-1.146v1.172c0.05095-0.3949 0.05095-0.8025 0-1.172z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m56.86 28.69c-0.2038-0.1529-1.745-0.3482-1.745-0.3482l-3.264-0.01274c-0.5987-0.2802-0.8247-1.55-0.8247-4.288 0.3312-2.471-1.401-4.726-3.86-5.057-8.881 2.622-2.133 1.723-8.917 0.08917-9.376 2.498-1.771 2.843-8.917 1.185-9.755 0.1624-1.828 6.409-9.006 1.274-2.458-0.3312-4.726 1.401-5.044 3.86-0.06369 0.3949-0.06369 0.8025 0 1.197h-0.03821l0.03821 10.97c-0.3312 2.458 1.401 4.726 3.86 5.057 6.352-0.265 5.107-9.398 5.057 1.223-0.3312 2.458 1.401 4.726 3.86 5.057 4.281-2.589 4.384 6.516 7.599 8.173 0.8025 2.051 10.28-0.168 11.56-0.1043 4.928 2.479 12.18-2.03 10.32-4.553 0.05095-0.3949 0.05095-8.165 0-8.56 0.1783-2.076 1.185-13.71-0.6751-15.16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m32.48 46.77c-0.293 0.5095-0.7006 0.9426-1.172 1.287 0.2165-0.4331 0.5987-0.8789 1.172-1.287z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m33.13 41.53c0.03821 0.8789 0.02548 2.879-0.01274 3.401z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m32.48 46.77c-0.293 0.5095-0.7006 0.9426-1.172 1.287 0.2165-0.4331 0.5987-0.8789 1.172-1.287z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m33.12 44.93 0.01274-3.401c0.03821 0.8789 0.02548 2.879-0.01274 3.401z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m33.19 25.31h-0.01274l0.01274-1.223c0.05095 0.3949 0.05095 0.8025 0 1.223z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m42.11 24.11v-1.172c0.05095 0.3694 0.05095 0.777 0 1.172z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m55.69 38.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m39.17 56.81c-2.577 0-9.977 4.548-8.467-7.881z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fcea2b",
  d: "m57.31 33.52c0-1.9 0-4.118-2.011-4.118z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "line"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m41.94 37.24v7.074c-0.3346 2.512 1.428 4.82 3.936 5.156 2.509 0.3352 4.813-1.43 5.148-3.942 0.0536-0.4028 0.0536-0.8107 0-1.213l-5.19e-4 -20.48c0.3346-2.512-1.428-4.82-3.936-5.156s-4.813 1.43-5.148 3.942v1.301c0.3346-2.512-1.428-4.82-3.936-5.156s-4.813 1.43-5.148 3.942v2.427c0.3346-2.512-1.428-4.82-3.936-5.156s-4.813 1.43-5.148 3.942c-0.02619 0.8746-0.02488 1.613-0.08098 2.513 0.3346-2.512-1.428-4.82-3.936-5.156s-4.813 1.43-5.148 3.942c-0.0536 0.4028-0.0536 0.8107-0.02011 1.214l0.02064 11.19c-0.3346 2.512 1.428 4.82 3.936 5.156 2.509 0.3352 4.813-1.43 5.148-3.942 0.0536-0.4028 0.0536-0.8107 0-1.213v-1.341l0.04022-3.517-0.04023 11.27c-0.3346 2.512 1.428 4.82 3.936 5.156s4.813-1.43 5.148-3.942c0.0536-0.4028 0.0536-3.548 0-3.951v-5.012l-0.04075-4.248 0.04075 14.6c-0.3346 2.512 1.428 4.82 3.936 5.156s4.813-1.43 5.148-3.942c0.0536-0.4028 0.0536-0.8107 0-1.213l0.08046-15.82z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m55.78 38.49"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m57.43 52.08c-0.2117 2.896-2.598 5.149-5.497 5.19h-12.98"
}), /*#__PURE__*/React.createElement("line", {
  x1: 57.43,
  x2: 57.43,
  y1: 52.08,
  y2: 33.52,
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "m38.95 57.27c-2.625 0-7.445 0.6149-7.445-3.105"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "m57.43 33.52c0-1.938 0-4.201-2.049-4.201"
}));

function SvgOpenmojiFist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenmojiFist);
export default __webpack_public_path__ + "static/media/openmoji-fist.c373a5e2.svg";
export { ForwardRef as ReactComponent };